import client from './client';

export async function getAdminAccountList(params) {
  const res = await client.get('/admin/account', { params });
  return res.data;
}

export async function getAdminAccount(adminId) {
  const res = await client.get(`/admin/account/${adminId}`);
  return res.data;
}

export async function createAdminAccount(payload) {
  const res = await client.post('/admin/account', payload);
  return res.data;
}

export async function updateAdminAccount(adminId, payload) {
  const res = await client.put(`/admin/account/${adminId}`, payload);
  return res.data;
}

export async function deactivateAdminAccount(adminId, updatedBy) {
  const res = await client.delete(`/admin/account/${adminId}`, { params: { updatedBy } });
  return res.data;
}

export async function changeAdminPassword(adminId, newPassword) {
  const res = await client.put(`/admin/account/${adminId}/password`, null, { params: { newPassword } });
  return res.data;
}

export async function getAdminRoleList() {
  const res = await client.get('/admin/account/role');
  return res.data;
}

export async function createAdminRole(payload) {
  const res = await client.post('/admin/account/role', payload);
  return res.data;
}

export async function updateAdminRole(roleCode, payload) {
  const res = await client.put(`/admin/account/role/${roleCode}`, payload);
  return res.data;
}
